






















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

//import IntercomMixin from '@/components/helpers/intercom-mixin';
import NavbarSupportMixin from '@/views/layout/navigation/mixins/navbar-support-mixin';


@Component
export default class NavbarSupport extends mixins(NavbarSupportMixin)  {
  @Prop({ default: '' }) 
  listClass: string;

  @Prop({ default: '' })
  contentClass: string;

  @Prop() 
  nudgeLeft: number;

  @Prop() 
  nudgeRight: number;

  @Prop() 
  nudgeTop: number;

  @Prop() 
  nudgeBottom: number;

  @Prop()
  offsetX: boolean; 

  @Prop()
  offsetY: boolean; 

  handleAction(event: any) {
    this.value = false;
    this.$emit('action', event);
  }

  get menuList(): Bemob.ListItem[] {
    return [
      this.actions.openLiveSupport,
      this.actions.closeLiveSupport,
      this.actions.helpCenterLink,
      this.actions.quickStart,
      this.actions.blog,
      this.actions.createTemporaryPassword,
      this.actions.forceDesktopView,
      this.actions.forceMobileView
    ];
  }

  get menuListFiltered() {
    return this.menuList.filter((item) => typeof item.showCondition === 'undefined' || item.showCondition);
  }

  value: boolean = false;
}
